import React, { useState, useEffect } from 'react';
import './FilterSearch.css';

const FilterSearch = ({
  field_name,
  selectedItems,
  setSelectedItems,
  addNode,
  removeNode,
  updateNode,
  path,
  pathExists,
}) => {
  const [searchValue, setSearchValue] = useState(selectedItems[field_name] || '');

  useEffect(() => {
    // console.log(searchValue);
    // console.log(selectedItems[field_name])
    if (searchValue != selectedItems[field_name]) {    // Set a timeout to delay function execution until typing has stopped
      const delayDebounceFn = setTimeout(() => {
        const fullPath = [...path, { key: field_name, value: 0 }];

        if (searchValue) {
          // Add or update the node if there's a search query
          if (pathExists(fullPath)) {
            updateNode(fullPath, { is_group: 0, value: searchValue }, field_name);
          } else {
            addNode(fullPath, { is_group: 0, value: searchValue });
          }
          setSelectedItems((prev) => ({
            ...prev,
            [field_name]: searchValue,
          }));
        } else if (pathExists(fullPath)) {
          // Only remove the node if the path exists and `searchValue` is empty
          removeNode(fullPath);
          setSelectedItems((prev) => ({
            ...prev,
            [field_name]: '',
          }));
        }

      }, 500); // 500ms delay

      // Cleanup the timeout if `searchValue` changes within the delay
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchValue]); // Only run when `searchValue` changes

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <div style={{ width: '100%' }}>
      <input
        type="search"
        className="products-sidebar-input"
        placeholder="Search"
        value={searchValue}
        onChange={handleSearchChange}
      />
    </div>
  );
};

export default FilterSearch;
